import PropTypes from 'prop-types';

import styling from '../../../services/styling';
import IconSvg from '../../IconSvg';

const CaretLeft = ({ color, height, width, ...rest }) => (
  <IconSvg
    {...rest}
    color={color}
    height={height}
    viewBox="0 0 14 21"
    width={width}
  >
    <g fill="currentColor">
      <polygon points="11,21 13.5,18.5 5.5,10.5 13.5,2.5 11,0 0.5,10.5" />
    </g>
  </IconSvg>
);

CaretLeft.propTypes = {
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};

CaretLeft.defaultProps = {
  color: styling.colors.theme.pureWhite,
  height: 21,
  width: 14,
};

export default CaretLeft;
